<template>
    <div id="app-mobile">
        <div class="content">
            <slot />
        </div>
    </div>
</template>

<script>
import HeaderVue from "@/components/Header/Header.vue";
export default {
    components: {
        HeaderVue,
    },
    data() {
        return {};
    },
    mounted() {},
};
</script>

<style scoped>
.footer {
    border-top: 1px solid #dadce0;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100vw;
    min-height: 48px;
}
.menu-item {
    color: rgb(0, 0, 0, 0.7);
}
.menu-item.disabled {
    color: #ccc !important;
}
.menu-item.active {
    color: #03a9f4;
    border-top: 2px solid #03a9f4;
}
.menu-item:not(.disabled):active {
    background: rgb(3, 169, 244, 0.1);
}
</style>
